<button class="mat-button " mat-button [matMenuTriggerFor]="menuList">
  <fa-icon [icon]="faCalendar"></fa-icon>
  Periode: {{selectedYearChange | async}}
</button>
<mat-menu #menuList="matMenu">
  <button mat-menu-item *ngFor="let year of yearsList" (click)="selectedListItemEvent(year)"> {{year}}</button>
</mat-menu>
